export default __webpack_public_path__ + "e9cdbe0.png";